module.exports = __webpack_public_path__ + "static/media/star-white.2064b106.svg";